import { CricketGameState } from "./cricket";
import { HalvesGameState } from "./halves";
import { PLAYER } from "./players";
import { TEAM } from "./teams";
import { X01GameState } from "./x01";

export enum GAME_STATE {
  NOT_STARTED,
  ACTIVE,
  PENDING,
  FINISHED
}

export interface GameRequests {
  continue?: PLAYER;
  undo?: PLAYER;
  restart?: PLAYER;
}

export interface BaseGameState {
  gameState: GAME_STATE;
  throwNumber: number;
  currentPlayer: PLAYER;
  winner?: TEAM;
  requests?: GameRequests;
}


export interface BasePlayerState {
  name: string;
  totalThrows: number;
}

export interface BaseTeamState {
  score: number;
}

export type OnlineGameState = X01GameState | CricketGameState;
export type GameState = OnlineGameState | HalvesGameState;